import { z } from "zod";

import {
  AnnualIncome,
  CreditScoreRange,
  MostRecentEviction,
} from "@/.zenstack/logical-prisma-client";
import { enumValues } from "@/lib/utils-client";

// This is how I want to use the schema...
// const LeaseFormSchema = ForLeaseScalarSchema.pick({
//   availableFrom: true,
//   leaseTermMonths: true,
// });

// const ScreeningFormSchema = TenantScreeningCriteriaScalarSchema.pick({
//   isEnabled: true,
//   creditScoreRange: true,
//   annualIncome: true,
//   mostRecentEviction: true,
// });

// const FormSchema = LeaseFormSchema.merge(ScreeningFormSchema);
// type FormData = z.infer<typeof FormSchema>;

/**
 * Error-only schema for Screening/Lease form (blocking validation)
 */
export const ScreeningErrorSchema = z.object({
  // Zod v4: removed required_error, use message instead
  availableFrom: z.date({ message: "Available from date is required" }),
  leaseTermMonths: z.coerce.number({
    message: "Lease term months is required",
  }),
  isEnabled: z.boolean({ message: "Is enabled is required" }),
  creditScoreRange: z.enum(enumValues(CreditScoreRange)), //.exclude("NOT_PROVIDED")
  annualIncome: z.enum(enumValues(AnnualIncome)), //.exclude("NOT_PROVIDED")
  mostRecentEviction: z.enum(enumValues(MostRecentEviction)), //.exclude("NOT_PROVIDED")
});

/**
 * Warning-only schema for Screening/Lease form (non-blocking recommendations)
 * Exported for reuse in listing-validation.ts
 */
export const ScreeningWarningSchema = z
  .object({
    availableFrom: z.date(),
    leaseTermMonths: z.coerce.number(),
    isEnabled: z.boolean(),
    creditScoreRange: z.enum(enumValues(CreditScoreRange)),
    annualIncome: z.enum(enumValues(AnnualIncome)),
    mostRecentEviction: z.enum(enumValues(MostRecentEviction)),
  })
  .superRefine((data, ctx) => {
    // Recommend enabling tenant screening for better tenant quality
    if (!data.isEnabled) {
      ctx.addIssue({
        code: "custom",
        message:
          "Consider enabling tenant screening to help find qualified tenants and reduce risk",
        severity: "warning",
        path: ["isEnabled"],
      });
    }

    // FORM-LEVEL WARNING: When screening is enabled, recommend setting at least one criterion
    if (data.isEnabled) {
      const allCriteriaNotRequired =
        data.creditScoreRange === CreditScoreRange.NOT_REQUIRED &&
        data.annualIncome === AnnualIncome.NOT_REQUIRED &&
        data.mostRecentEviction === MostRecentEviction.NOT_REQUIRED;

      if (allCriteriaNotRequired) {
        ctx.addIssue({
          code: "custom",
          message:
            "Tenant screening is enabled but no criteria are set. Consider setting at least one screening criterion (credit score, income, or eviction history) to effectively filter applicants.",
          severity: "warning",
          path: [], // Empty path makes this a form-level warning
        });
      }
    }
  });
